//SCSS
import '../scss/main.scss';
//Vendor-scripts
import './vendor/slick.min.js'
import './vendor/jQuery.maskedinput.min.js'
import './vendor/jquery-ui.min.js'
//Bootstrap
// import 'bootstrap';

//HTML
import '../../index.html';

    $(document).ready(function() {
        $('.title__scroll__btn').on('click', function(e){
            e.preventDefault();
            var id  = $(this).attr('href');
            var top = $(id).offset().top; // получаем координаты блока
            $('body, html').animate({scrollTop: top}, 800); // плавно переходим к блоку
        });
    });      
